import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { ClubMemberSearch } from '../ClubMemberSearch/ClubMemberSearch';

export const ClubMemberManagerPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle" className="d-inline">
        Club Member Manager
      </h1>
      <ClubMemberSearch />
    </Layout>
  );
};
